import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import { hashHistory } from 'react-router'
import Store from './store'
import SearchBar from './SearchBar'
import { Button } from 'hljd'
import Table from './table'
import AddCustomer from './addCustomer/index'
import Upload from './upload'
import { observer, Provider } from 'mobx-react'
import { toJS } from 'mobx'
import { Flex } from 'hljd'
import ExportModal from './ExportModal'
import { getMerchantInfo, isExperienceStore } from '@util'
import { isRoleService } from '@util'

@observer
class CustomerList extends Component {
  constructor(props) {
    super(props)
    this.store = new Store()
    let storeData = []
    // 是否显示弹框
    const customerVisible =
      props.location.query.customerVisible == '1' ? true : false
    if (customerVisible) {
      storeData.push({ type: 'customerVisible', value: customerVisible })
    }

    // 是否带有user_phone
    const user_phone = props.location.query.user_phone || ''
    if (user_phone) {
      storeData.push({ type: 'initValue', value: { user_phone } })
    }

    // 是否未查看
    const look_at = props.location.query.look_at
    if (look_at == 0) {
      storeData.push({ type: '$filters', value: { look_at: 0 } })
    }

    this.store.setStoreData(storeData)
    hashHistory.replace(props.location.pathname)
  }

  // 只有加盟店管理员和体验店店长显示导出
  showExportBtn = () => {
    const { is_store_manager } = getMerchantInfo()
    return (!isExperienceStore() && !isRoleService()) || is_store_manager == 1
  }

  componentDidMount() {
    this.store.getStaffList()
  }

  render() {
    const {
      customerVisible,
      setStoreData,
      createCustomer,
      extraData
    } = this.store
    const initValue = toJS(this.store.initValue)

    return (
      <Provider listStore={this.store}>
        <HeaderView>
          <div
            style={{
              borderBottom: '1px solid #E7E7E7',
              margin: '0 -20px',
              padding: '0 20px'
            }}
          >
            <SearchBar query={this.props.location.query} store={this.store} />
          </div>

          <Flex sp vc style={{ height: 72 }}>
            <span style={{ color: '#333' }}>
              当前筛选<span>{extraData.total_count || 0}</span>人， 总客户数
              <span>{extraData.sum_count || 0}</span>人
            </span>

            <div>
              {this.showExportBtn() && (
                <Button
                  style={{ marginRight: 10, width: 88 }}
                  onClick={() =>
                    setStoreData([{ type: 'exportModalVisible', value: true }])
                  }
                >
                  导出
                </Button>
              )}

              <Button
                style={{ width: 88 }}
                type="primary"
                onClick={() =>
                  setStoreData([{ type: 'customerVisible', value: true }])
                }
              >
                录入客户
              </Button>
            </div>
          </Flex>

          <Table store={this.store} />

          <AddCustomer
            type="new"
            visible={customerVisible}
            initValue={initValue}
            onClose={() =>
              setStoreData([
                { type: 'customerVisible', value: false },
                { type: 'initValue', value: {} }
              ])
            }
            onOk={createCustomer}
            listStore={this.store}
          />
          <Upload />

          <ExportModal />
        </HeaderView>
      </Provider>
    )
  }
}

export default CustomerList
